export const subAccounts = {
  title: 'Sub-Accounts',
  subtitle: 'Team-Mitglieder und Reseller-Kunden verwalten',
  navTitle: 'Sub-Accounts',
  invite: 'Einladen',
  mySubAccounts: 'Meine Sub-Accounts',
  myParents: 'Meine Eltern-Accounts',
  filterAll: 'Alle',
  search: 'Suchen...',
  loading: 'Lade Sub-Accounts...',
  empty: 'Keine Sub-Accounts',
  emptyChildren: 'Du hast noch keine Sub-Accounts. Lade Team-Mitglieder oder Reseller-Kunden ein.',
  emptyParents: 'Du bist keinem Eltern-Account zugeordnet.',
  billingShared: 'Gemeinsame Abrechnung',
  billingIndependent: 'Eigene Abrechnung',
  status: {
    active: 'Aktiv',
    pending: 'Ausstehend',
    deactivated: 'Deaktiviert',
    expired: 'Abgelaufen'
  },
  roles: {
    viewer: 'Betrachter',
    editor: 'Bearbeiter',
    manager: 'Manager'
  },
  roleDescriptions: {
    viewer: 'Nur lesender Zugriff auf Domains, Mail und Hosting – keine Änderungen.',
    editor: 'Lesen und Bearbeiten von Domains, Mail und Hosting – kein Löschen.',
    manager: 'Voller Zugriff inkl. Löschen. Abrechnung, Zahlungen und Kontoeinstellungen bleiben dem Eigentümer vorbehalten.'
  },
  inviteSlider: {
    title: 'Sub-Account einladen',
    subtitle: 'Lade ein Team-Mitglied oder einen Reseller-Kunden ein',
    email: 'E-Mail-Adresse',
    emailPlaceholder: "email{'@'}beispiel.de",
    type: 'Beziehungstyp',
    billingMode: 'Abrechnungsmodus',
    teamRole: 'Team-Rolle',
    label: 'Bezeichnung',
    labelPlaceholder: 'z.B. Entwickler-Team, Agentur XY...',
    send: 'Einladung senden'
  },
  editSlider: {
    title: 'Sub-Account bearbeiten',
    type: 'Typ',
    status: 'Status',
    billingMode: 'Abrechnungsmodus',
    teamRole: 'Team-Rolle',
    label: 'Bezeichnung'
  },
  deactivateModal: {
    title: 'Sub-Account deaktivieren?',
    message: 'Möchtest du die Beziehung zu {account} wirklich deaktivieren?',
    warning: 'Der Sub-Account verliert den Zugriff auf deine Ressourcen.',
    confirm: 'Deaktivieren'
  },
  contextBanner: {
    acting: 'Du agierst als {context}',
    teamScoped: 'eingeschränkt auf deine Team-Rolle',
    returnBtn: 'Zurück zum eigenen Account'
  },
  inviteAccept: {
    title: 'Einladung annehmen',
    subtitle: '{name} hat dich als Sub-Account eingeladen',
    from: 'Von',
    type: 'Typ',
    billing: 'Abrechnung',
    accept: 'Einladung annehmen',
    decline: 'Ablehnen',
    loading: 'Einladung wird geladen...',
    errorTitle: 'Fehler',
    invalidToken: 'Diese Einladung ist ungültig oder abgelaufen.',
    loadError: 'Die Einladung konnte nicht geladen werden.',
    acceptError: 'Die Einladung konnte nicht angenommen werden.',
    successTitle: 'Einladung angenommen',
    successMessage: 'Du bist jetzt als Sub-Account verknüpft.',
    goHome: 'Zur Startseite',
    goDashboard: 'Zum Dashboard'
  },
  resources: {
    tab: 'Ressourcen',
    title: 'Sub-Account Ressourcen',
    subtitle: 'Übersicht aller Domains und Mail-Accounts deiner Sub-Accounts',
    loading: 'Lade Ressourcen...',
    empty: 'Keine Ressourcen',
    emptyMessage: 'Deine Sub-Accounts haben noch keine Domains oder Mail-Accounts.',
    domains: 'Domains',
    mailAccounts: 'Mail-Accounts',
    domainStatus: {
      active: 'Aktiv',
      pending_delete: 'Gekündigt',
      deleted: 'Gelöscht',
      suspended: 'Gesperrt',
      trade_out: 'Transfer',
      transfer_pending: 'Transfer läuft',
      external: 'Extern'
    },
    activeUntil: 'Aktiv bis',
    switchTo: 'Verwalten',
    totalDomains: 'Domains gesamt',
    totalMail: 'Mail-Accounts gesamt'
  },
  notifications: {
    inviteSent: 'Einladung gesendet',
    inviteSentMessage: 'Die Einladung wurde erfolgreich gesendet.',
    updated: 'Aktualisiert',
    updatedMessage: 'Die Sub-Account-Beziehung wurde aktualisiert.',
    deactivated: 'Deaktiviert',
    deactivatedMessage: 'Die Sub-Account-Beziehung wurde deaktiviert.'
  }
} as const
